/**
 * Layout modes and height classes (ui-ux §2.3) — the JS mirror of the CSS breakpoints, read by the renderer for camera
 * framing and by every layout function. Pure. Owner: UI/Visual (F3).
 */
export type LayoutMode = 'xs' | 'phone' | 'land' | 'phablet' | 'tablet' | 'desk' | 'wide';
export type HeightClass = 'h-tall' | 'h-mid' | 'h-short' | 'h-tiny';

/** `(orientation: landscape) and (max-height: 520px)` wins over the width modes, as in the CSS. */
export function layoutMode(w: number, h: number): LayoutMode {
  if (w > h && h <= 520) return 'land';
  if (w >= 1440 && h >= 521) return 'wide';
  if (w >= 1024 && h >= 521) return 'desk';
  if (w >= 768) return 'tablet';
  if (w >= 600) return 'phablet';
  if (w < 360) return 'xs';
  return 'phone';
}

/** `h-tall` ≥ 780 · `h-mid` 700–779 · `h-short` 600–699 · `h-tiny` < 600 (independent of width). */
export function heightClass(h: number): HeightClass {
  if (h >= 780) return 'h-tall';
  if (h >= 700) return 'h-mid';
  if (h >= 600) return 'h-short';
  return 'h-tiny';
}
